<template>
	<div class="like">
		<button v-if="isFavorited" class="btn btn-plain btn-like" @click.prevent="unFavorite(product)">
			<svg class="ticon"><use xlink:href="/images/icons.svg#icon-heart-full"></use></svg>
		</button>
		<button v-else class="btn btn-plain btn-like" @click.prevent="favorite(product)">
			<svg class="ticon"><use xlink:href="/images/icons.svg#icon-heart"></use></svg>
		</button>
	</div>
</template>

<script>
export default {
	name: "Favorites",
	props: ['product', 'favorited'],

	data: function() {
		return {
			isFavorited: '',
		}
	},
	computed: {
		isFavorite() {
			return this.favorited;
		},
	},
	methods: {
		// TODO: single function refactor?
		favorite(product) {
			console.log(product);
			axios.post(`/favorite/add/${product}`)
				.then(response => this.isFavorited = true)
				.catch(response => {});
		},

		unFavorite(product) {
			axios.post(`/favorite/remove/${product}`)
				.then(response => this.isFavorited = false)
				.catch(response => {});
		}
	},
	mounted() {
		this.isFavorited = this.isFavorite ? true : false;
	}
}
</script>
